import React, { useState } from 'react';
import styles from './RecipeDrawer.module.css';

// ============================================================
// RecipeDrawer.js — slide-in panel showing saved recipes
// ============================================================
export default function RecipeDrawer({ calc, onClose, onOpenShared }) {
  const { loadRecipe, deleteRecipe, getSavedRecipes } = calc;
  const [recipes, setRecipes] = useState(() => getSavedRecipes());

  const handleDelete = (recipe) => {
    if (window.confirm(`Delete "${recipe.recipeName}"? This cannot be undone.`)) {
      deleteRecipe(recipe.id);
      setRecipes(getSavedRecipes()); // refresh immediately
    }
  };

  return (
    <div className={styles.drawerOverlay} onClick={onClose}>
      <div className={styles.drawer} onClick={e => e.stopPropagation()}>
        <div className={styles.drawerHeader}>
          <span className={styles.drawerTitle}>My Recipes</span>
          <button className={styles.drawerClose} onClick={onClose}>✕</button>
        </div>

        {/* A recipe shared from Mesa Robles arrives as a file, not as a save. */}
        <button className={styles.openShared} onClick={onOpenShared}>
          📥 Open shared recipe…
        </button>

        {recipes.length === 0 ? (
          <div className={styles.emptyState}>No saved recipes yet. Build a recipe and hit "Save Recipe".</div>
        ) : (
          <div className={styles.recipeList}>
            {[...recipes].reverse().map(recipe => (
              <div key={recipe.id} className={styles.recipeItem}>
                <div className={styles.recipeItemLeft}>
                  <div className={styles.recipeItemName}>{recipe.recipeName}</div>
                  <div className={styles.recipeItemMeta}>
                    {recipe.sausageStyle || recipe.cookMethod}
                    {' · '}{new Date(recipe.savedAt).toLocaleDateString()}
                  </div>
                </div>
                <div className={styles.recipeItemActions}>
                  <button
                    className={styles.recipeLoad}
                    onClick={() => { loadRecipe(recipe); onClose(); }}
                  >
                    Load
                  </button>
                  <button
                    className={styles.recipeDelete}
                    onClick={() => handleDelete(recipe)}
                    title="Delete recipe"
                  >
                    🗑
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
